import {Component, Input} from "@angular/core";
import {CommonModule} from '@angular/common';
import {FieldOkItemComponent} from "@softline/dynamic";

@Component({
    selector: 'soft-field-ok-data-view',
    imports: [CommonModule],
    templateUrl: './artikelkz7.list-view.html',
    styleUrls: ['./artikelkz7.list-view.scss']
})
export class Artikelkz7ListView implements FieldOkItemComponent<any>{

  @Input() item: any;

  constructor() {}
}
